module.exports = __webpack_public_path__ + "ba4dae43f71a1a30a6a5faa28c2072d9.svg";